import React, {
  Fragment,
} from 'react';
import {
  notEmptyString,
} from '@populateui/utils';
import type {
  AuthorizationOptionProps,
} from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/types';
import SanitizedHtml from 'views/EMR/components/SanitizedHtml';

export default function AuthorizationNotes({ option }: AuthorizationOptionProps) {
  const recordsWithNotes = option.authorizations.filter((authorization) => (
    notEmptyString(authorization.notes)
  ));

  return (
    <div className="leading-5">
      {recordsWithNotes.map((authorization, index) => (
        <Fragment key={authorization.patientAuthorizationId}>
          {index > 0 && <hr className="my-3 border-gray-200" />}
          <SanitizedHtml content={authorization.notes ?? ''} />
        </Fragment>
      ))}
    </div>
  );
}
